import { Flex } from '@ironhack/design-system2/components/flex';
import { Icon } from '@ironhack/design-system2/components/icon';
import { Text } from '@ironhack/design-system2/components/text';
import dynamic from 'next/dynamic';
import { type ReactElement } from 'react';

import { type DatoIconBlock } from '@/lib/datocms/types';
import { toUpperPascalCase } from '@/lib/utils';
import { NavMenuColumn } from '../types';

type Props = Pick<NavMenuColumn, 'icon' | 'subtitle' | 'title'>;

type IconProps = Pick<DatoIconBlock, 'color' | 'name'>;

const NavHeadingIcon = (props: IconProps): ReactElement | null => {
  const { name, color } = props;

  const iconName = toUpperPascalCase(name);
  // @ts-expect-error -- Can't figure out how to type the function
  const IconAsset = dynamic(() =>
    import('@ironhack/design-system2/icons').then((icons) => icons[iconName])
  );

  return IconAsset ? (
    <Icon
      as={IconAsset}
      boxSize="22px"
      {...(color && { color: `icon.${color}` })}
    />
  ) : null;
};

export const NavColumnHeading = (props: Props): ReactElement => {
  const { icon, subtitle, title } = props;

  return (
    <Flex direction="column" gap={0.5}>
      <Flex align="center" gap={1}>
        {icon && <NavHeadingIcon {...icon} />}
        <Text textStyle="lBold">{title}</Text>
      </Flex>

      {subtitle && (
        <Text
          color="electricBlue.80"
          {...(icon && { ml: [null, null, null, 1] })}
        >
          {subtitle}
        </Text>
      )}
    </Flex>
  );
};
